import { Controller } from 'stimulus';
import dayjs from 'dayjs';

const formatDate = (timestamp) => dayjs(timestamp).format('YYYY-MM-DD HH:mm UTC');

const hover = (fx) => (index, options, content, row) => {
  return `
    <div class="hidden md:block bg-white rounded-md p-4 shadow-sm text-center">
      <p class="text-sm lg:text-md text-gray-600">
        ${formatDate(row.date)}
      </p>

      <div>
        <span class="text-lg lg:text-2xl">${fx(row)}</span><span class="lg:text-lg pl-1">${options.postUnits}</span>
      </div>
    </div>
  `;
};

export default class extends Controller {
  static targets = ['responseTime', 'availability', 'rangeSwitch'];

  connect() {
    this.responseTimeChart =
      Morris.Line({
        element: this.responseTimeTarget,
        data: [],
        xkey: 'date',
        ykeys: ['average'],
        labels: ['Mean Response Time'],
        postUnits: "ms",
        lineWidth: 1,
        pointSize: 0,
        lineColors: ["#299F72"],
        dateFormat: formatDate,
        hoverCallback: hover(row => row.average),
      });

    this.availabilityChart =
      Morris.Line({
        element: this.availabilityTarget,
        data: [],
        xkey: 'date',
        ykeys: ['percentage'],
        labels: ['Availability'],
        postUnits: "%",
        lineWidth: 1,
        pointSize: 0,
        lineColors: ["#299F72"],
        ymin: 0,
        ymax: 100,
        dateFormat: formatDate,
        hoverCallback: hover(row => row.percentage),
      });

    this.load('daily');
  }

  setRange(ev) {
    this.rangeSwitchTargets.map(el => el.classList.remove('active'));
    ev.target.classList.add('active');

    const range = ev.target.getAttribute('data-range');
    this.load(range);
  }

  disconnect() {
  }

  load(range) {
    fetch(this.responseTimeUrl(range))
      .then(response => response.json())
      .then(data => this.responseTimeChart.setData(data));

    fetch(this.availabilityUrl(range))
      .then(response => response.json())
      .then(data => this.availabilityChart.setData(data));
  }

  responseTimeUrl = (range) => this.element.getAttribute('data-response-time-url').replace('daily', range);
  availabilityUrl = (range) => this.element.getAttribute('data-availability-url').replace('daily', range);
}
